import React, { useEffect, useMemo, useState, createContext } from "react";
//import { useOutletContext } from "react-router-dom";

import API from "../../API";

import { HouseholdWith } from "../../models";
import OrdersList from "./OrdersList";

// Components

const ContextAdmin = createContext<any>(null);
let ContextValue: any;

interface Props {}

const Admin: React.FC<Props> = (props) => {
  //const { handleToOrder } = useOutletContext<any>();
  const [repullHouseholds, setRepullHouseholds] = useState<string>("");
  const [uncompleteOrder, setUncompleteOrder] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [query, setQuery] = useState<string>("");

  useEffect(() => {
    setLoading(true);
    API.fetchUncomplete()
      .then((data) => setUncompleteOrder(Array.isArray(data) ? data : []))
      .finally(() => setLoading(false));
  }, [repullHouseholds]);

  const visibleOrders = useMemo(() => {
    const term = query.trim().toLowerCase();
    return uncompleteOrder
      .filter((order) =>
        (order.household_name || "").toLowerCase().includes(term)
      )
      .sort((a, b) => (a.order_date < b.order_date ? 1 : -1));
  }, [uncompleteOrder, query]);

  const handleCompleted = (household: HouseholdWith) => {
    API.updateHousehold(household.id, { is_completed: true });
    setRepullHouseholds(Math.random().toString());
  };

  const handleUpdateRepull = (householdId: string, note: string) => {
    API.createContactNote(householdId, note);

    setTimeout(() => {
      setRepullHouseholds(Math.random().toString());
    }, 5000);
  };

  const handleDelete = (id: string) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this entry?"
    );

    if (confirmation) {
      API.deleteHousehold(id);
      setRepullHouseholds(Math.random().toString());
    }
  };

  ContextValue = {
    handleCompleted,
    handleDelete,
    handleUpdateRepull,
  };

  return (
    <ContextAdmin.Provider value={ContextValue}>
      <div className="orders_page">
        <div className="orders_bar">
          <h3 className="orders_title">Pending Orders</h3>
          <input
            className="orders_search"
            type="text"
            placeholder="Search by family name…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <span className="orders_count">
            {visibleOrders.length} order{visibleOrders.length === 1 ? "" : "s"}
          </span>
        </div>

        {loading ? (
          <div className="orders_empty">Loading orders…</div>
        ) : visibleOrders.length === 0 ? (
          <div className="orders_empty">
            {uncompleteOrder.length === 0
              ? "No pending orders."
              : "No orders found."}
          </div>
        ) : (
          <div className="orders_card_list">
            <OrdersList households={visibleOrders} />
          </div>
        )}
      </div>
    </ContextAdmin.Provider>
  );
};

export { Admin as default, ContextAdmin };
